export default () => ({
  shoppingCart: {
    user: {},
    tempUser: {},
    products: [],
    guestCart: [],
  },
});
